module.exports = __webpack_public_path__ + "static/media/trusted-adult.c9cbca5d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reportcentre/trusted-adult.jpeg
// module id = 2942
// module chunks = 0